import React from 'react';
import { styled } from 'linaria/react';
import Image from 'next/image';
import { List } from '@mtsbank/ui-kit';
import { withTheme } from '@shared/lib';
import { Spacer } from '@shared/ui/atoms';
import genshinTooltip from '@shared/assets/images/cyber/genshinTooltip.jpg';
export const GenshinTooltip = () => <WrapperTooltip>
    <Heading>Как&nbsp;найти свой UID в&nbsp;Genshin Impact?</Heading>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <WrapperList>
      <List data={[{
      id: 1,
      text: 'Откройте приложение Genshin Impact. Нажмите на\u00A0свой аватар в\u00A0левом верхнем углу главного экрана.'
    }, {
      id: 2,
      text: 'Во\u00A0вкладке «Профиль» вы увидите UID под аватаркой профиля'
    }]} size="md" sizemob="md" />
    </WrapperList>
    <Spacer space={20} spacetablet={20} spacemob={20} />
    <ImageWrapper>
      <Image src={genshinTooltip} width={536} height={140} alt="genshin" style={{
      borderRadius: '16px'
    }} />
    </ImageWrapper>
  </WrapperTooltip>;
const _exp = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSCompact;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.xs;
const _exp4 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.regular;
const _exp5 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.xs;
const WrapperTooltip = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperTooltip",
  class: "wuwftsc",
  propsAsIs: false,
  vars: {
    "wuwftsc-0": [_exp()],
    "wuwftsc-1": [_exp2()],
    "wuwftsc-2": [_exp3(), "px"],
    "wuwftsc-3": [_exp4()],
    "wuwftsc-4": [_exp5(), "px"]
  }
}));
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.state.active;
const WrapperList = withTheme(/*#__PURE__*/styled('div')({
  name: "WrapperList",
  class: "w114msy8",
  propsAsIs: false,
  vars: {
    "w114msy8-0": [_exp6()]
  }
}));
const _exp7 = /*#__PURE__*/() => ({
  theme
}) => theme.font.family.MTSWide;
const _exp8 = /*#__PURE__*/() => ({
  theme
}) => theme.font.size.md;
const _exp9 = /*#__PURE__*/() => ({
  theme
}) => theme.font.weight.medium;
const _exp0 = /*#__PURE__*/() => ({
  theme
}) => theme.font.lineHeight.sm;
const _exp1 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.text.primary;
const Heading = withTheme(/*#__PURE__*/styled('div')({
  name: "Heading",
  class: "h73rhh8",
  propsAsIs: false,
  vars: {
    "h73rhh8-0": [_exp7()],
    "h73rhh8-1": [_exp8(), "px"],
    "h73rhh8-2": [_exp9()],
    "h73rhh8-3": [_exp0(), "px"],
    "h73rhh8-4": [_exp1()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ih8wgrr",
  propsAsIs: false
});

require("./GenshinTooltip.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./GenshinTooltip.tsx");